export default "__VITE_ASSET__C1UC2R8u__"